/* eslint-disable react/jsx-one-expression-per-line */
import { Heading } from '@lili/lili-frontend-common';
import { ISummaryData } from '../../../types';
import useStore from '../../../store';
import { TextWithCopyItem } from './TextWithCopyItem';

export const BillingAddress = () => {
  const {
    customer: { accountAddress },
  }: ISummaryData = useStore((state) => state.summary);

  const accountAddressToCopy = `${accountAddress.line1}, ${accountAddress.line2 ? `${accountAddress.line2}, ` : ''}${accountAddress.city}, ${accountAddress.state}, ${accountAddress.country}, ${accountAddress.postalCode}`;
  return (
    <div className='flex flex-col justify-center mt-auto w-full mb-[32px]'>
      <div className='w-full  border-b-2 border-solid border-surface-primary-bw-03 '>
        <TextWithCopyItem title='Billing Address' addressToCopy={accountAddressToCopy} />
      </div>
      <Heading.H10 className='text-text-main-secondary pb-1 pt-2' text- title={accountAddress.line1}>
        {accountAddress.line1},
      </Heading.H10>
      {accountAddress.line2 && (
        <Heading.H10 className='text-text-main-secondary ' title={accountAddress.line2}>
          {accountAddress.line2},
        </Heading.H10>
      )}
      <div className='flex pb-1 gap-[1px]'>
        <Heading.H10 className='text-text-main-secondary ' title={accountAddress.city}>
          {accountAddress.city},
        </Heading.H10>
        <Heading.H10 className='text-text-main-secondary ' title={accountAddress.state}>
          {accountAddress.state},
        </Heading.H10>
        <Heading.H10 className='text-text-main-secondary ' title={accountAddress.country}>
          {accountAddress.country}
        </Heading.H10>
      </div>
      <Heading.H10 className='text-text-main-secondary ' title={accountAddress.postalCode}>
        {accountAddress.postalCode}
      </Heading.H10>
    </div>
  );
};
